import axios from 'axios'

const API_URL = process.env.VUE_APP_AI_AGENT_API_BASE_URL

class SessionService {
  /**
   * Get all sessions for the current user, optionally filtered by agent
   */
  getSessions (agentId = null) {
    const params = agentId ? { agentId } : {}
    return axios.get(API_URL + 'sessions', { params })
  }

  /**
   * Get a specific session with all messages
   */
  getSessionById (sessionId) {
    return axios.get(API_URL + 'sessions/' + sessionId)
  }

  /**
   * Create a new chat session.
   * @param {object} sessionData - { agentId, projectId?, title? }
   * @param {string|null} hostContextJson - JSON string for X-Agent-Context header (from aiAgentHostContext mixin)
   */
  createSession (sessionData, hostContextJson = null) {
    const headers = {}
    if (hostContextJson) headers['X-Agent-Context'] = hostContextJson
    return axios.post(API_URL + 'sessions', sessionData, { headers })
  }

  /**
   * Update session (e.g., rename)
   */
  updateSession (sessionId, sessionData) {
    return axios.put(API_URL + 'sessions/' + sessionId, sessionData)
  }

  /**
   * Get ALL sessions for an agent (admin view — includes other users' and anonymous sessions)
   */
  getAgentSessions (agentId) {
    return axios.get(API_URL + 'sessions/agent/' + agentId)
  }

  /**
   * Delete a session
   */
  deleteSession (sessionId) {
    return axios.delete(API_URL + 'sessions/' + sessionId)
  }

  /**
   * Get messages for a specific session
   */
  getSessionMessages (sessionId) {
    return axios.get(API_URL + 'sessions/' + sessionId + '/messages')
  }
}

export default new SessionService()
